/**
 * Locale-aware quantity formatting shared by the inventory (physical) and channel-stock
 * (availability) features — lifted from `features/inventory/lib/format.ts` per
 * design-stock-channels-page §3 (FSD forbids a cross-feature import). Quantities are decimal
 * `numeric(14,3)` platform-wide (weight goods, plan-platform-001 principle 9) — never truncate.
 */
import { getIntlLocale } from '@/shared/i18n';

export function formatQuantity(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat(getIntlLocale(), { maximumFractionDigits: 3 }).format(value);
}

export function formatSignedQuantity(value?: number | null): string {
  if (value === null || value === undefined || Number.isNaN(value)) return '—';
  const formatted = new Intl.NumberFormat(getIntlLocale(), { maximumFractionDigits: 3 }).format(
    Math.abs(value),
  );
  if (value > 0) return `+${formatted}`;
  if (value < 0) return `−${formatted}`;
  return formatted;
}
